module.exports = __webpack_public_path__ + "static/media/profile_details.3a95724f.svg";